// extracted by mini-css-extract-plugin
module.exports = {"scoreContainer":"Summary_scoreContainer__3AL2Z"};